// extracted by mini-css-extract-plugin
export default {"video":"Video_video__ARfi9","qmeta":"Video_qmeta__yT9Xe"};